export default __webpack_public_path__ + "static/media/AccountActivated.faf8ced7.svg";